import { literals } from "./literals";

const {role} = literals

export const roleRestrictions = {

    TRUCK_FASTAG_NUMBER_UPDATE :  [
        role.admin,
        role.partner_manager,
        role.partner_support,
        role.tl_sales,
    ],

    TRUCK_SUBSCRIPTION_REVERSAL: [
        role.admin,
        role.partner_manager,
        role.partner_support,
    ],

    TRUCK_BRANDING_ADD: [
        role.admin,
        role.partner_manager,
        role.sourcing_manager,
    ]

}
 

